/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Invoice_HistoryInputs */

const en_plan_invoice_history = /** @type {(inputs: Plan_Invoice_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoices`)
};

const es_plan_invoice_history = /** @type {(inputs: Plan_Invoice_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturas`)
};

/**
* | output |
* | --- |
* | "Invoices" |
*
* @param {Plan_Invoice_HistoryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_invoice_history = /** @type {((inputs?: Plan_Invoice_HistoryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Invoice_HistoryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_invoice_history(inputs)
	return en_plan_invoice_history(inputs)
});